import axios from 'axios'
import qs from 'qs'

const api = axios.create({
  baseURL: CONFIG.apiUrl,
  paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }),
  timeout: 60e3, // NOTE adapt this to current network conditions?
})

// Export a function to install this plugin with Vue 3
export const setupAxios = app => {
  app.config.globalProperties.$api = api
}

export default api
